import type { MilkdownPlugin } from '@milkdown/ctx'

import {
  acceptAllDiffsCmd,
  acceptDiffChunkCmd,
  acceptDiffRangeCmd,
  clearDiffReviewCmd,
  rejectDiffChunkCmd,
  rejectDiffRangeCmd,
  startDiffReviewCmd,
  startDiffReviewFromDocCmd,
} from './diff-commands'
import { diffConfig } from './diff-config'
import { diffPlugin } from './diff-plugin'

export * from './types'
export { diffConfig } from './diff-config'
export { computeDocDiff } from './diff-compute'
export type {
  ComputeDocDiffOptions,
  ComputeDiffRange,
  DiffIgnoreAttrs,
} from './diff-compute'
export {
  diffPlugin,
  diffPluginKey,
  getPendingChanges,
  isChangeRejected,
} from './diff-plugin'
export {
  acceptAllDiffsCmd,
  acceptDiffChunkCmd,
  acceptDiffRangeCmd,
  clearDiffReviewCmd,
  rejectDiffChunkCmd,
  rejectDiffRangeCmd,
  startDiffReviewCmd,
  startDiffReviewFromDocCmd,
} from './diff-commands'

/// The milkdown diff plugin.
export const diff: MilkdownPlugin[] = [
  diffConfig,
  diffPlugin,
  startDiffReviewCmd,
  startDiffReviewFromDocCmd,
  acceptDiffChunkCmd,
  acceptDiffRangeCmd,
  rejectDiffChunkCmd,
  rejectDiffRangeCmd,
  acceptAllDiffsCmd,
  clearDiffReviewCmd,
]
